import { FC } from 'react';
import { useField } from 'formik';
import PhoneInput, { PhoneInputProps } from '@/components/ui/PhoneInput/PhoneInput.tsx';

interface FormikPhoneInputProps extends Omit<PhoneInputProps, 'value' | 'onChange' | 'errorMessage' | 'touched'> {
	name: string;
	defaultValue?: string;
}

const FormikPhoneInput: FC<FormikPhoneInputProps> = ({ name, ...props }) => {
	const [{ value, onBlur }, { error, touched }, { setValue }] = useField(name);

	return (
		<PhoneInput
			{...props}
			name={name}
			onBlur={onBlur}
			value={value}
			onChange={newValue => setValue(newValue)}
			errorMessage={error}
			touched={touched}
		/>
	);
};

export default FormikPhoneInput;
